import * as React from 'react';

import { translate } from '~l10n/client';
import { Action } from '~shared/components/ActionMenu';
import { IconShare } from '~shared/components/icons/standard';
import { WorkspaceItem } from '~teacher/hook/workspaces/useWorkspaceItems';

/**
 * Opens the Share dialog for a single workspace quiz. Visible to all members —
 * the dialog itself is read-only for Editors/Viewers (see
 * WorkspaceShareQuizDialog / deriveWorkspaceShareState).
 */
export function useShareWorkspaceQuizAction() {
  const [shareWorkspaceQuizId, setShareWorkspaceQuizId] = React.useState<
    string | null
  >(null);

  const shareQuizAction = React.useMemo(
    () =>
      ({
        key: 'share',
        title: translate('Share'),
        icon: <IconShare />,
        action: ({ data, close }) => {
          const first = data[0];
          if (first?.type === 'quiz') {
            setShareWorkspaceQuizId(first.id);
            close();
          }
        },
        constraint: ({ data }: { data: WorkspaceItem[] }) =>
          data.every((item) => item.type === 'quiz'),
        disabled: ({ data }) => data.length > 1,
      } as Action<WorkspaceItem>),
    []
  );

  return {
    shareQuizAction,
    shareWorkspaceQuizId,
    closeShareDialog: () => setShareWorkspaceQuizId(null),
  };
}
